import React from "react";
import { useNavigate } from "react-router-dom";
import style from "./AuthHeader.module.css";
import DunoLogo from "../../assests/duno_main_logo.png";

function AuthHeader() {
  const navigate = useNavigate();

  return (
    <header className={style.authHeader}>
      <div className={style.authHeaderInner}>
        <div className={style.logoWrap} onClick={() => navigate("/login")} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && navigate("/login")}>
          <img src={DunoLogo} alt="Duno Club" />
        </div>
      </div>
    </header>
  );
}

export default AuthHeader;
